<div class="flex h-full min-w-[280px] flex-col gap-3 p-3">
  <div class="flex items-center justify-between h-12">
    <em
      class="flex items-center justify-center w-12 h-12 material-symbols-outlined icon-regular select-none"
      [class.text-blue-600]="canNavigatePrevYear()"
      [class.cursor-pointer]="canNavigatePrevYear()"
      [class.text-gray-400]="!canNavigatePrevYear()"
      [class.cursor-not-allowed]="!canNavigatePrevYear()"
      (click)="onPrevYear()">
      arrow_back
    </em>
    <span class="sh2 text-gray-1000">{{ yearHeaderLabel() }}</span>
    <em
      class="flex items-center justify-center w-12 h-12 material-symbols-outlined icon-regular select-none"
      [class.text-blue-600]="canNavigateNextYear()"
      [class.cursor-pointer]="canNavigateNextYear()"
      [class.text-gray-400]="!canNavigateNextYear()"
      [class.cursor-not-allowed]="!canNavigateNextYear()"
      (click)="onNextYear()">
      arrow_forward
    </em>
  </div>

  @switch (view()) {
    @case ("month") {
      <div class="grid grid-cols-3 gap-2">
        @for (month of monthLabels; track $index) {
          <button
            type="button"
            class="b1 py-4 px-8 rounded-md text-center border-2 border-solid bg-transparent"
            [class.border-blue-600]="isMonthSelected($index)"
            [class.border-transparent]="!isMonthSelected($index)"
            [class.cursor-pointer]="isMonthAvailable($index)"
            [class.text-gray-1000]="isMonthAvailable($index)"
            [class.text-gray-600]="!isMonthAvailable($index)"
            [class.cursor-not-allowed]="!isMonthAvailable($index)"
            [disabled]="!isMonthAvailable($index)"
            (click)="onMonthClick($index)">
            {{ month }}
          </button>
        }
      </div>
    }
    @case ("quarter") {
      <div class="grid grid-cols-2 gap-2">
        @for (q of quarters; track q) {
          <button
            type="button"
            class="py-4 px-12 rounded-md text-center border-2 border-solid bg-transparent"
            [class.border-blue-600]="isQuarterSelected(q)"
            [class.border-transparent]="!isQuarterSelected(q)"
            [class.cursor-pointer]="isQuarterAvailable(q)"
            [class.text-gray-1000]="isQuarterAvailable(q)"
            [class.text-gray-600]="!isQuarterAvailable(q)"
            [class.cursor-not-allowed]="!isQuarterAvailable(q)"
            [disabled]="!isQuarterAvailable(q)"
            (click)="onQuarterClick(q)">
            <div class="b2">Q{{ q + 1 }}</div>
            <div class="c1 text-gray-800">{{ quarterRangeLabel(q) }}</div>
          </button>
        }
      </div>
    }
    @case ("year") {
      <div class="grid grid-cols-3 gap-2">
        @for (year of years(); track year) {
          <button
            type="button"
            class="b1 py-4 px-8 rounded-md text-center border-2 border-solid bg-transparent"
            [class.border-blue-600]="isYearSelected(year)"
            [class.border-transparent]="!isYearSelected(year)"
            [class.cursor-pointer]="isYearAvailable(year)"
            [class.text-gray-1000]="isYearAvailable(year)"
            [class.text-gray-400]="!isYearAvailable(year)"
            [class.cursor-not-allowed]="!isYearAvailable(year)"
            [disabled]="!isYearAvailable(year)"
            (click)="onYearClick(year)">
            {{ year }}
          </button>
        }
      </div>
    }
  }

  @if (footerLabel()) {
    <div class="b2 mt-auto text-center text-gray-800">{{ footerLabel() }}</div>
  }
</div>
